import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { ContactCards } from "../components/ContactCards";
import { ContactForm } from "../components/ContactForm";
import { Reveal } from "../components/Reveal";
import { MapPlaceholder } from "../components/home/LocationSection";

export default function Contact() {
  const { t } = useLanguage();
  return (
    <main data-testid="contact-page">
      <SEOHead title={t.meta.contact.title} description={t.meta.contact.description} />
      <PageHeader eyebrow={t.contactPage.eyebrow} title={t.contactPage.title} text={t.contactPage.text} crumb={t.nav.contact} testId="contact-header" />
      <section className="container-x grid gap-12 pb-24 lg:grid-cols-12 md:pb-32">
        <Reveal className="lg:col-span-5">
          <ContactCards compact />
          <div className="mt-4"><MapPlaceholder className="aspect-[4/3]" /></div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <div id="anfrage" className="scroll-mt-28">
            <p className="eyebrow">{t.contactPage.formTitle}</p>
            <h2 className="h3 mt-3">{t.contactPage.formText}</h2>
            <div className="mt-8"><ContactForm /></div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
